module.exports = __webpack_public_path__ + "static/img/tokenRFID-1.af26ea2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/tokenRFID-1.svg
// module id = 4vCU
// module chunks = 0